<span *ngIf="user | async as profile">{{profile.name}}</span>